import type { ModelDefinition } from "@/__main__/data-model.mjs";
import createModel from "@/__main__/data-model.mjs";

const model = {
  nonce: String,
} satisfies ModelDefinition;

export const PayPalTokenizeResponseModel = createModel(model);
